import { getStorage } from "firebase/storage"
import { initializeApp } from "firebase/app"
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { getFirestore, serverTimestamp } from "firebase/firestore"
import { getAuth } from "firebase/auth"
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { states } from "@/main_store";
import { showModal } from "@/main_store/modal";

// import { onBackgroundMessage } from "firebase/messaging/sw"
// import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

const firebaseConfig = {
    apiKey: "AIzaSyDBmDCCpJ-D2VRSwVMmNvvWCw9S0dKTEQo",
    authDomain: "heart-b8a79.firebaseapp.com",
    projectId: "heart-b8a79",
    storageBucket: "heart-b8a79.appspot.com",
    messagingSenderId: "195380091625",
    appId: "1:195380091625:web:cdf06867f2387e2b12ae78"
};

// init firebase
const app = initializeApp(firebaseConfig)

const functions = getFunctions(app);

// connectFunctionsEmulator(functions, "127.0.0.1", 5001);

// init services
const db = getFirestore(app)

const projectAuth = getAuth()
const projectStorage = getStorage(app);

// timestamp
const timestamp = serverTimestamp


// Initialize Firebase Cloud Messaging and get a reference to the service
const messaging = getMessaging(app);

onMessage(messaging, (payload) => {
    console.log('Foreground message received:', payload);

    // Read from data object (notification object removed to prevent duplicates)
    const notificationTitle = payload.data?.title || 'התראה חדשה';
    const notificationOptions = {
        body: payload.data?.body || '',
        icon: payload.data?.icon || '/img/icons/android-chrome-192x192.png',
        tag: 'coordinator-inquiry',
        requireInteraction: false
    };

    // DEBUG: Check notification support and permission
    console.log('[DEBUG] Notification in window:', 'Notification' in window);
    console.log('[DEBUG] Notification.permission:', 'Notification' in window ? Notification.permission : 'N/A');
    console.log('[DEBUG] Title:', notificationTitle);
    console.log('[DEBUG] Body:', notificationOptions.body);
    console.log('[DEBUG] Tab hidden:', document.hidden);

    // ALWAYS show modal FIRST - ensures notification is never missed
    console.log('[DEBUG] Showing modal notification');
    showModal(notificationTitle + '\n' + notificationOptions.body, 'warning');

    // Additionally, try to show browser notification if tab is hidden/backgrounded
    // (This provides system notifications when user switches tabs or minimizes window)
    if (document.hidden && 'serviceWorker' in navigator && 'Notification' in window && Notification.permission === 'granted') {
        console.log('[DEBUG] Tab is hidden - attempting browser notification via service worker');

        navigator.serviceWorker.ready.then(registration => {
            console.log('[DEBUG] Service worker ready, calling showNotification');
            return registration.showNotification(notificationTitle, {
                ...notificationOptions,
                vibrate: [200, 100, 200],  // Vibration pattern for mobile
                data: { url: payload.data?.link || '/' }  // Data for click handler
            });
        }).then(() => {
            console.log('[DEBUG] Browser notification displayed successfully via service worker');
        }).catch(err => {
            console.error('[DEBUG] Failed to show browser notification:', err);
        });
    } else {
        console.log('[DEBUG] Skipping browser notification. Reason:',
            !document.hidden ? 'Tab is visible (modal shown instead)' :
            !('serviceWorker' in navigator) ? 'No service worker' :
            !('Notification' in window) ? 'Notifications not supported' :
            'Permission not granted (current: ' + Notification.permission + ')');
    }
});

// Detect if running on iOS
export const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

// Detect if app is running as standalone PWA (installed to home screen)
export const isStandalonePWA = () => {
    return window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true;
};

// Check if browser supports notifications
export const checkNotificationSupport = () => {
    if (!('Notification' in window)) {
        console.log('This browser does not support notifications');
        return false;
    }
    if (!('serviceWorker' in navigator)) {
        console.log('This browser does not support service workers');
        return false;
    }
    return true;
};

export const requestFCMToken = async () => {
    try {
        // Check if notification API is supported
        if (!checkNotificationSupport()) {
            console.error('Notifications not supported in this browser');
            return null;
        }

        // Check permission status first
        if (Notification.permission !== 'granted') {
            console.log('Notification permission not granted. Current status:', Notification.permission);
            return null;
        }

        // Permission is granted, request token
        console.log('Requesting FCM token...');
        const currentToken = await getToken(messaging, {
            vapidKey: "BARegqbP6YBfVq9KarLc4C4yFfKgOka9Q3iW7tLtpZKAZ5vGjSVDAxG1DOUr9cBC6Uu14lU4xzLcDmj5FoHlj_k"
        });

        if (currentToken) {
            console.log('FCM token generated successfully');
            states.value.notificationToken = currentToken;
            return currentToken;
        } else {
            console.log('No registration token available');
            return null;
        }
    } catch (err) {
        console.error('An error occurred while retrieving token:', err);
        return null;
    }
};

export const requestPermission = async () => {
    try {
        // Check if notification API is supported
        if (!checkNotificationSupport()) {
            throw new Error('Notifications not supported in this browser');
        }

        console.log('Requesting notification permission...');
        const permission = await Notification.requestPermission();

        if (permission === 'granted') {
            console.log('Notification permission granted.');

            // After permission granted, try to get FCM token
            const token = await requestFCMToken();
            return { success: true, token, permission };
        } else {
            console.log('Notification permission denied:', permission);
            return { success: false, token: null, permission };
        }
    } catch (err) {
        console.error('Error requesting notification permission:', err);
        return { success: false, token: null, permission: 'denied', error: err };
    }
};

// Create a ReCaptchaEnterpriseProvider instance using your reCAPTCHA Enterprise
// site key and pass it to activate().
// const appCheck = initializeAppCheck(app, {
//     provider: new ReCaptchaEnterpriseProvider('6LdSEDwoAAAAAFRPf0KeNWycT74pbJIuvTjdmMO8'),
//     isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
// });

export { db, projectAuth, timestamp, projectStorage, functions, httpsCallable, messaging }